import * as Yup from "yup";
import { errorMessages } from "../../../constants";
import { PricingProvider } from "../../../types/eval/PricingProvider";
import { numericUtils } from "../../../utils";

const otherProviderMaxLength = 256;

export const StartEvalSchema = Yup.object().shape({
    usePricingService: Yup.string().required(errorMessages.required),
    pricingProvider: Yup.array()
        .of(Yup.string())
        .when("usePricingService", {
            is: "Yes",
            then: (schema) =>
                schema
                    .min(1, errorMessages.empty)
                    .required(errorMessages.empty),
            otherwise: (schema) => schema.max(0),
        }),
    otherProviderName: Yup.string().when("pricingProvider", {
        is: (pricingProvider: PricingProvider[]) =>
            pricingProvider.includes(PricingProvider.Other),
        then: () =>
            Yup.string()
                .required(errorMessages.empty)
                .max(
                    otherProviderMaxLength,
                    errorMessages.maxLength(otherProviderMaxLength)
                ),
        otherwise: () => Yup.string().optional().nullable(),
    }),
    portfolioSize: Yup.string().required(errorMessages.required),

    percentageBreakdown: Yup.object({
        usBSL: Yup.number(),
        usMM: Yup.number(),
        eurBSL: Yup.number(),
        eurMM: Yup.number(),
    }).test(
        "at-least-one-breakdown",
        errorMessages.chooseAtLeastOne,
        (breakdowns) => {
            return Object.values(breakdowns).some(
                (b) => numericUtils.isNumber(b) && b > 0
            );
        }
    ),
});
